<template>
  <account-modal class="wallet-type-create-modal">
    <template slot="heading">Assign wallet type</template>

    <template slot="content">
      <v-layout
        class="row--data mt-2"
        row
      >
        <v-flex xs6>
          <v-subheader class="v-subheader--dense">Integrators</v-subheader>
        </v-flex>

        <v-flex xs6>
          <v-radio-group
            id="integrator"
            v-model="form.type"
            class="mt-0"
            hint="Required field"
            persistent-hint
            :error-messages="getValidationErrorMessage('type')"
          >
            <v-radio
              v-for="(option, key) in integratorsOptions"
              :id="`integrator-${option.value.toLowerCase()}`"
              :key="key"
              color="primary"
              :label="option.name"
              :value="option.value"
            />
          </v-radio-group>
        </v-flex>
      </v-layout>

      <error-alert :error="error" />
    </template>

    <template slot="actions">
      <v-btn
        color="light-blue darken-3"
        flat
        :disabled="loading"
        @click="onSaveButtonClick"
      >assign</v-btn>

      <v-btn
        color="light-blue darken-3"
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </account-modal>
</template>

<script>
  import { mapGetters } from 'vuex'

  // Events
  import { EVENT_ACCOUNT_UPDATE } from '@/events/accounts'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import IntegratorsApi from '@/services/Api/IntegratorsApi'

  // Mixins
  import form from '@/mixins/form'
  import modal from '@/mixins/modal'
  import flashMessages from '@/mixins/flashMessages'

  // Component
  import AccountModal from '@/components/accounts/AccountModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  function getDefaultFormData () {
    return {
      type: null
    }
  }

  export default {
    name: 'WalletTypeCreateModal',
    components: {
      AccountModal,
      ErrorAlert
    },
    mixins: [form, modal, flashMessages],
    data () {
      return {
        addIntegratorApiRequest: new ApiRequest(IntegratorsApi.addWalletIntegrator),
        form: getDefaultFormData()
      }
    },
    computed: {
      ...mapGetters('integrators', ['integratorOptions']),
      integratorsOptions () {
        return this.integratorOptions
      },
      accountId () {
        return this.modal.data.account.accountId
      },
      profileId () {
        return this.modal.data.profileId
      },
      requestData () {
        return this.parsedFormInput
      },
      loading () {
        return this.addIntegratorApiRequest.loading
      },
      error () {
        return this.addIntegratorApiRequest.error
      }
    },
    methods: {
      onSaveButtonClick () {
        this.addIntegratorApiRequest.execute(this.accountId, this.requestData)
          .then(() => {
            this.$eventHub.$emit(EVENT_ACCOUNT_UPDATE, this.profileId)

            this.showSuccessFlashMessage('Account has been successfully edited.')
          })
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      }
    }
  }
</script>
